import { cn } from '@/lib/utils';
import { CATEGORIES } from '../categories';

interface CategoryTabsProps {
  active: string;
  onSelect: (id: string) => void;
  className?: string;
}

/** Base tab: floating type with no containers. `group` lets the icon react to hover. */
const TAB_BASE = cn(
  'group relative flex min-w-max cursor-pointer items-baseline justify-center gap-1.5 whitespace-nowrap',
  'border-none bg-transparent px-0 py-1 text-[13px] font-black transition-all duration-300',
  '[transition-timing-function:cubic-bezier(0.16,1,0.3,1)]',
);

/** Category filter tabs with text-only active states. */
export function CategoryTabs({ active, onSelect, className }: CategoryTabsProps) {
  const isActive = (id: string) => active === id;

  return (
    <div className={cn('w-full', className)}>
      <div className="mx-auto flex w-fit max-w-full gap-6 overflow-x-auto pb-1 [-ms-overflow-style:none] [scrollbar-width:none] sm:gap-8 [&::-webkit-scrollbar]:hidden">
        <button
          type="button"
          className={cn(TAB_BASE, isActive('all') ? 'text-accent' : 'text-lo hover:text-hi')}
          onClick={() => onSelect('all')}
        >
          All
        </button>
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            type="button"
            className={cn(TAB_BASE, isActive(c.id) ? 'text-accent' : 'text-lo hover:text-hi')}
            onClick={() => onSelect(c.id)}
          >
            {c.name}
          </button>
        ))}
      </div>
    </div>
  );
}
